import ITEM_ALIASES from "../constants/itemAliases";

export const normalizeItemName = (value) => {
  if (!value) return "";
  return String(value)
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/['"]/g, "")
    .replace(/[/:(),.-]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
};

export const getCftValueForItem = (itemName, mapping) => {
  const normalized = normalizeItemName(itemName);
  if (!normalized) return { cftPerItem: "", matched: false, normalizedItem: "" };
  const canonical = ITEM_ALIASES[normalized] || normalized;
  const cft = mapping[canonical];
  if (typeof cft === "number") {
    return { cftPerItem: cft, matched: true, normalizedItem: canonical };
  }
  return { cftPerItem: "", matched: false, normalizedItem: canonical };
};

export const sanitizeQuantity = (value) => {
  if (value === "" || value === null || value === undefined) {
    return { value: 0, isValid: false, error: "Quantity is required" };
  }

  const parsed = Number(value);
  if (!Number.isFinite(parsed)) {
    return { value: 0, isValid: false, error: "Enter a valid number" };
  }
  if (parsed < 0) {
    return { value: 0, isValid: false, error: "Quantity cannot be negative" };
  }
  if (!Number.isInteger(parsed)) {
    return { value: parsed, isValid: false, error: "Use a whole number" };
  }

  return { value: parsed, isValid: true, error: "" };
};

export const extractNumericQuantity = (rawValue) => {
  if (rawValue === "" || rawValue === null || rawValue === undefined) {
    return { value: "", error: "Quantity is required" };
  }
  const raw = String(rawValue).trim();
  const match = raw.match(/-?\d+/);
  if (!match) return { value: "", error: `Could not parse quantity: ${raw}` };
  const value = Number(match[0]);
  if (!Number.isFinite(value)) return { value: "", error: `Could not parse quantity: ${raw}` };
  return { value, error: "" };
};

export const calculateRowCft = (quantity, cftPerItem) => {
  const safeQuantity = Number.isFinite(quantity) && quantity > 0 ? quantity : 0;
  const parsedCft = Number(cftPerItem);
  const safeCft = Number.isFinite(parsedCft) && parsedCft > 0 ? parsedCft : 0;
  return safeQuantity * safeCft;
};

export const calculateGrandTotal = (rows) => {
  return rows.reduce((sum, row) => {
    const rowTotal = Number.isFinite(row.totalCft) ? row.totalCft : 0;
    return sum + rowTotal;
  }, 0);
};

export const getTotalQuantity = (rows) => {
  return rows.reduce((sum, row) => {
    const quantity = Number(row.quantity);
    return sum + (Number.isFinite(quantity) && quantity > 0 ? quantity : 0);
  }, 0);
};

export const formatCft = (value) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return "0";
  return Number.isInteger(numeric) ? String(numeric) : numeric.toFixed(2);
};
